<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
        <show
            :id="id"
            model-def="subscriptions"
            model-class="subscription"
            topClass=''
        ></show>

        <crud v-if="$store.getters.checkModulePermissions('act')" class="mb-4"
            title='Record Telefonici'
            action-icon='phone'
            model-def='telephonerecords'
            :sub-filters='{subscriptions: id}'
            action-position='absolute'
            :position-left="true"
            :position-right="false"
            direction="right"
        ></crud>

        <activities
            class="pb-4"
            :model-id="id"
            model-class="subscription"
            model-def="subscriptions"
        ></activities>

        <dms-uploader
            :id="id"
            attachable-type="subscriptions"
        ></dms-uploader>
    </v-row>
</template>

<script>
    import Activities from '@/components/common/Activities'

    export default {
        name: 'subscription',
        components: {
            Activities,
        },

        props: {
            id: Number,
        },

        data() {
            return {
            }
        },

        created() {
            this.$store.commit('endProgress')
        }
    }
</script>

<style>

</style>